
import { create } from "zustand";
import { devtools } from "zustand/middleware";




const storeApi = (set) => ({

    activeProducto: null,
    productos: [],
    isLoadingProducto: false,
    totalProducto: 0,
    
});






export const useProductosStore = create()(
    devtools(
        storeApi
    )
)
